// Zenzena – STARTER PACK konfigurátor.
// Mimo sekci ze stejného důvodu jako CSS: picker žije i v quick-buy modalu
// na výpisech produktů. Konfigurace se čte z data-atributů elementu.
(() => {
if (window.customElements.get('starter-pack-picker')) return;

// \x7b = "{" – escape, aby řetězec nikdy nevypadal jako Liquid tag
const DEFAULT_FORMAT = '\x7b\x7bamount\x7d\x7d';

const formatMoney = (cents, format) => {
  const value = cents / 100;
  const group = (n, sep, decimals) => {
    const fixed = decimals === 0 ? Math.round(n).toFixed(0) : n.toFixed(decimals);
    const [int, dec] = fixed.split('.');
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return dec ? grouped + ',' + dec : grouped;
  };

  return (format || DEFAULT_FORMAT).replace(/\x7b\x7b\s*(\w+)\s*\x7d\x7d/g, (_, token) => {
    switch (token) {
      case 'amount': return group(value, ',', 2);
      case 'amount_no_decimals': return group(value, ',', 0);
      case 'amount_with_comma_separator': return group(value, '.', 2);
      case 'amount_no_decimals_with_comma_separator': return group(value, '.', 0);
      case 'amount_with_space_separator': return group(value, ' ', 2);
      case 'amount_no_decimals_with_space_separator': return group(value, ' ', 0);
      case 'amount_with_apostrophe_separator': return group(value, '’', 2);
      case 'amount_with_period_and_space_separator': return group(value, ' ', 2);
      default: return group(value, ' ', 0);
    }
  });
};

class StarterPackPicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.packSize = parseInt(this.dataset.packSize, 10) || 5;
    this.discountPct = parseFloat(this.dataset.discountPct) || 0;
    // Pevna sleva v halerich. Kdyz je vyplnena, procenta se ignoruji –
    // stejne poradi jako v Liquidu, jinak by se cena v modalu rozesla
    // s cenou vyrenderovanou serverem.
    this.discountFixed = parseInt(this.dataset.discountFixed, 10) || 0;
    this.moneyFormat = this.dataset.moneyFormat || DEFAULT_FORMAT;

    this.items = Array.from(this.querySelectorAll('[data-zzsp-item]'));
    this.state = new Map();

    this.els = {
      remaining: this.querySelector('[data-zzsp-remaining]'),
      dots: Array.from(this.querySelectorAll('[data-zzsp-dot]')),
      now: this.querySelector('[data-zzsp-now]'),
      was: this.querySelector('[data-zzsp-was]'),
      save: this.querySelector('[data-zzsp-save]'),
      totals: this.querySelector('[data-zzsp-totals]'),
      hint: this.querySelector('[data-zzsp-hint]'),
      error: this.querySelector('[data-zzsp-error]'),
      submit: this.querySelector('.zzsp-picker__submit'),
      // querySelectorAll, ne querySelector – cena je na stránce dvakrát:
      // v hlavním bloku a ve sticky liště. Ve quick-buy modalu na výpisu
      // nejsou ani jednou, proto všude prázdné seznamy nevadí.
      heroPrefix: document.querySelectorAll('[data-zzsp-hero-prefix]'),
      heroNow: document.querySelectorAll('[data-zzsp-hero-now]'),
      heroWas: document.querySelectorAll('[data-zzsp-hero-was]'),
      heroSave: document.querySelectorAll('[data-zzsp-hero-save]')
    };

    let running = 0;
    this.items.forEach((item) => {
      const id = item.dataset.variantId;
      const max = parseInt(item.dataset.max, 10) || 0;

      let initial = 0;
      if (item.hasAttribute('data-preselect') && max > 0 && running < this.packSize) {
        initial = 1;
        running += 1;
      }
      this.state.set(id, initial);

      item.querySelector('[data-zzsp-inc]')?.addEventListener('click', () => this.change(item, 1));
      item.querySelector('[data-zzsp-dec]')?.addEventListener('click', () => this.change(item, -1));
    });

    this.els.submit?.addEventListener('click', () => this.submit());
    this.render();

    // Deep link: /products/starter-pack#sestavit otevře konfigurátor rovnou
    // (použitelné v kampaních, e-mailech i pro rychlý náhled).
    if (window.location.hash === '#sestavit') {
      requestAnimationFrame(() => this.closest('x-modal')?.show());
    }
  }

  get total() {
    let n = 0;
    this.state.forEach((qty) => { n += qty; });
    return n;
  }

  get regularCents() {
    let n = 0;
    this.items.forEach((item) => {
      n += (this.state.get(item.dataset.variantId) || 0) * parseInt(item.dataset.price, 10);
    });
    return n;
  }

  change(item, delta) {
    const id = item.dataset.variantId;
    const max = parseInt(item.dataset.max, 10) || 0;
    const current = this.state.get(id) || 0;

    if (delta > 0 && this.total >= this.packSize) return;

    let next = current + delta;
    if (next < 0) next = 0;
    if (next > max) next = max;

    this.state.set(id, next);
    this.hideError();
    this.render();
  }

  render() {
    const total = this.total;
    const regular = this.regularCents;
    // Procentni vetev zustava beze zmeny vcetne zaokrouhleni – ochutnavka
    // a polevkovy mix na ni stoji a jakykoli posun by rozesel cenu s kodem
    // BALICEK3.
    let discounted;
    let saving;
    if (this.discountFixed > 0) {
      saving = Math.min(this.discountFixed, regular);
      discounted = regular - saving;
    } else {
      discounted = Math.round(regular * (1 - this.discountPct / 100));
      saving = regular - discounted;
    }
    const full = total === this.packSize;

    this.items.forEach((item) => {
      const id = item.dataset.variantId;
      const qty = this.state.get(id) || 0;
      const max = parseInt(item.dataset.max, 10) || 0;

      const out = item.querySelector('[data-zzsp-qty]');
      if (out) out.textContent = qty;

      item.toggleAttribute('data-selected', qty > 0);

      const dec = item.querySelector('[data-zzsp-dec]');
      const inc = item.querySelector('[data-zzsp-inc]');
      if (dec) dec.disabled = qty === 0;
      if (inc) inc.disabled = qty >= max || total >= this.packSize;
    });

    const remaining = this.packSize - total;
    if (this.els.remaining) {
      this.els.remaining.toggleAttribute('data-complete', remaining === 0);
      if (remaining === 0) {
        this.els.remaining.textContent = 'Balíček je kompletní 🎉';
      } else {
        this.els.remaining.textContent = '';
        this.els.remaining.append('Vyberte ještě ');
        const strong = document.createElement('strong');
        strong.textContent = remaining;
        this.els.remaining.append(strong, ' z ' + this.packSize);
      }
    }

    this.els.dots.forEach((dot, i) => dot.toggleAttribute('data-filled', i < total));

    if (this.els.totals) this.els.totals.hidden = total === 0;
    if (this.els.now) this.els.now.textContent = formatMoney(discounted, this.moneyFormat);

    if (this.els.was) {
      this.els.was.hidden = saving <= 0;
      this.els.was.textContent = formatMoney(regular, this.moneyFormat);
    }

    if (this.els.save) {
      this.els.save.hidden = saving <= 0;
      this.els.save.textContent = 'ušetříš ' + formatMoney(saving, this.moneyFormat);
    }

    if (this.els.hint) {
      if (this.discountFixed > 0) {
        this.els.hint.textContent = full
          ? 'Sleva i doprava se přidají automaticky v košíku.'
          : 'Sleva ' + formatMoney(this.discountFixed, this.moneyFormat) + ' platí na celý balíček.';
      } else if (this.discountPct > 0) {
        this.els.hint.textContent = full
          ? 'Sleva i doprava se přidají automaticky v košíku.'
          : 'Sleva ' + this.discountPct + '% platí na celý balíček.';
      } else {
        // Balicek bez slevy (ochutnavka, polevkovy mix): veta o sleve by
        // slibovala neco, co se v kosiku nestane.
        this.els.hint.textContent = full
          ? 'Do košíku ti přijdou jednotlivé porce.'
          : 'Vyber si, co chceš zkusit.';
      }
    }

    if (this.els.submit) this.els.submit.disabled = !full;

    if (full) {
      this.els.heroPrefix.forEach((el) => { el.hidden = true; });
      this.els.heroNow.forEach((el) => { el.textContent = formatMoney(discounted, this.moneyFormat); });
      this.els.heroWas.forEach((el) => {
        el.hidden = saving <= 0;
        el.textContent = formatMoney(regular, this.moneyFormat);
      });
      this.els.heroSave.forEach((el) => {
        // Bez slevy nema smysl psat "usetris 0 Kc" ani skrtnutou cenu.
        el.hidden = saving <= 0;
        el.textContent = 'ušetříš ' + formatMoney(saving, this.moneyFormat);
      });
    }
  }

  showError(message) {
    if (!this.els.error) return;
    this.els.error.hidden = false;
    this.els.error.textContent = message;
  }

  hideError() {
    if (this.els.error) this.els.error.hidden = true;
  }

  async submit() {
    const items = [];
    this.items.forEach((item) => {
      const qty = this.state.get(item.dataset.variantId) || 0;
      if (qty > 0) {
        items.push({
          id: parseInt(item.dataset.variantId, 10),
          quantity: qty,
          properties: { _starter_pack: 'STARTER PACK' }
        });
      }
    });

    if (!items.length) return;

    this.hideError();
    this.els.submit.setAttribute('aria-busy', 'true');
    this.els.submit.disabled = true;

    try {
      const bundled = new Set();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: bundled } })
      );
      const sections = [...bundled].join(',');

      // Snapshot košíku před přidáním – Shopify při nedostatku skladu vrátí 422,
      // ale část položek stejně přidá. Bez rollbacku by v košíku zůstal
      // rozbitý půlbalíček i se slevou balíčku.
      const before = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      const beforeByKey = new Map((before.items || []).map((line) => [line.key, line.quantity]));

      const addResponse = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections })
      });

      if (!addResponse.ok) {
        const error = await addResponse.json().catch(() => ({}));
        await this.rollback(beforeByKey);
        this.showError(
          error.description ||
          error.message ||
          'Některé z vybraných produktů už nejsou skladem v požadovaném množství. Uprav prosím výběr.'
        );
        return;
      }

      const cart = await this.applyDiscounts(sections);

      if (cart && cart.sections) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } })
        );
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.querySelector('cart-drawer')?.show();
      }

      // Funguje pro <x-modal> na produktovce i pro <quick-buy-modal> ve výpisu –
      // DialogElement na tuhle událost reaguje sám a zastaví její šíření.
      this.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: true }));

      const themeSettings = window.themeVariables ? window.themeVariables.settings : {};
      if (themeSettings.cartType === 'page' || themeSettings.pageType === 'cart') {
        window.location.href = Shopify.routes.root + 'cart';
      }
    } catch (error) {
      this.showError('Košík se nepodařilo aktualizovat. Zkus to prosím znovu.');
    } finally {
      this.els.submit.removeAttribute('aria-busy');
      this.render();
    }
  }

  /**
   * Vrátí košík do stavu před neúspěšným přidáním balíčku.
   * Řádky se párují přes line key, aby se nesáhlo na položky,
   * které tam zákazník měl už předtím.
   *
   * Musí to být JEDEN atomický /cart/update.js – po každém
   * /cart/change.js se klíče zbývajících řádků přegenerují,
   * takže postupné mazání by od druhého řádku minulo cíl.
   */
  async rollback(beforeByKey) {
    try {
      const after = await (await fetch(Shopify.routes.root + 'cart.js')).json();

      const updates = {};
      let changed = false;

      for (const line of after.items || []) {
        const previous = beforeByKey.get(line.key);
        const isPackLine = line.properties && line.properties._starter_pack;

        if (previous === undefined) {
          if (isPackLine) {
            updates[line.key] = 0;
            changed = true;
          }
        } else if (previous !== line.quantity) {
          updates[line.key] = previous;
          changed = true;
        }
      }

      if (!changed) return;

      await fetch(Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } catch (error) {
      console.warn('[starter-pack] rollback košíku selhal', error);
    }
  }

  async applyDiscounts(sections) {
    const wanted = [this.dataset.discountCode, this.dataset.shippingCode]
      .map((code) => (code || '').trim())
      .filter(Boolean);

    const body = { sections };

    if (wanted.length) {
      const currentCart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      const existing = (currentCart.discount_codes || [])
        .filter((discount) => discount.applicable)
        .map((discount) => discount.code);

      body.discount = [...new Set([...existing, ...wanted])].join(',');
    }

    const response = await fetch(Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!response.ok) return null;

    const updated = await response.json();

    const rejected = (updated.discount_codes || [])
      .filter((discount) => wanted.indexOf(discount.code) !== -1 && discount.applicable === false)
      .map((discount) => discount.code);

    if (rejected.length) {
      console.warn('[starter-pack] slevový kód se neaplikoval: ' + rejected.join(', '));
    }

    return updated;
  }
}

window.customElements.define('starter-pack-picker', StarterPackPicker);
})();
